module.exports = __webpack_public_path__ + "img/banner.efcf729d.png";